import styled from "styled-components";

type ContainerPropsType = {
  spacing?: string;
};

export const Container = styled.div<ContainerPropsType>`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  margin-bottom: ${(props) => (props.spacing ? props.spacing : 0)};
`;

export const Row = styled.div`
  display: flex;
  gap: 20px;

  &#remoteAccess {
    display: none;
  }

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
`;
type ContentPropsType = {
  flexGrow?: number;
  flexBasis?: string;
};

export const Content = styled.div<ContentPropsType>`
  flex-grow: ${(props) => (props.flexGrow ? props.flexGrow : 0)};
  flex-basis: ${(props) => (props.flexBasis ? props.flexBasis : "auto")};
  @media screen and (max-width: 960px) {
    flex-basis: 100%;
  }
  &.AddGroup {
    display: flex;
    justify-content: flex-end;
  }
  &.remote-access {
    display: inline-flex;
    gap: 10px;
  }
`;

export const LoadingContainer = styled.div`
  height: 370px;
  @media (min-width: 768px) {
    // height:
  }
`;

export const Img = styled.div`
  margin-top: 32px;
  fill: ${(props) => props.theme.colors.TooltipBorder};
  @media screen and (max-width: 700px) {
    margin-top: 25px;
  }
`;

export const Tooltip = styled.div`
  display: flex;
  align-items: center;
  /* Tooltip container */
  .tooltip {
    position: relative;
    display: inline-block;
  }

  .tooltip .tooltiptext {
    visibility: hidden;
    width: 180px;
    background-color: ${(props) => props.theme.colors.TooltipBackground};
    color: ${(props) => props.theme.colors.TooltipText};
    border-color: ${(props) => props.theme.colors.TooltipBorder};
    text-align: right;
    padding: 10px;
    border-radius: 6px 0px 6px 6px;
    font-family: Roboto, sans-serif;
    font-weight: bold;
    font-size: 12px;
    position: absolute;
    z-index: 1;
    opacity: 0;
    transition: opacity 0.3s;
    border: 1px solid;
  }

  .tooltip .tooltiptext {
    bottom: -320%;
    right: 70%;
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }

  @media screen and (max-width: 700px) {
    .tooltip .tooltiptext {
      margin-left: -280px;
    }
  }

  /* Tooltip arrow */
  .tooltip .tooltiptext::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
    display: none;
  }

  /* Show the tooltip text when you mouse over the tooltip container */
  .tooltip:hover .tooltiptext {
    visibility: visible;
    opacity: 1;
  }
`;
